var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeyChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 746,
    viewBox: "0 0 668 746",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.246 750.095L593.217 555.245C606.332 541.58 612.016 522.479 608.509 503.883L571.295 306.226C566.922 283.041 549.067 264.563 525.884 259.243L278.348 202.46C257.792 197.741 236.29 204.138 221.838 219.27L93.149 354.008C82.6642 364.975 76.8594 379.52 76.9309 394.665L77.8135 607.048C77.9075 630.166 91.603 651.181 112.859 660.798L338.445 762.967C361.589 773.442 388.795 768.284 406.246 750.095Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M434.659 343.8V304.517C434.659 303.133 433.526 302 432.142 302H370.832C369.447 302 368.314 303.133 368.314 304.517V380.705",
    stroke: "#C2D6D6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376.86 315.921H373.65V309.061H376.86V315.921ZM383.682 309.061H380.472V315.921H383.682V309.061ZM390.504 309.061H387.294V315.921H390.504V309.061ZM397.326 309.061H394.116V315.921H397.326V309.061ZM404.148 309.061H400.938V315.921H404.148V309.061Z",
    fill: "#EBF5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M376.86 329.565H373.65V322.705H376.86V329.565ZM383.682 322.705H380.472V329.565H383.682V322.705ZM390.504 322.705H387.294V329.565H390.504V322.705ZM397.326 322.705H394.116V329.565H397.326V322.705ZM404.148 322.705H400.938V329.565H404.148V322.705Z",
    fill: "#EBF5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M376.86 343.209H373.65V336.349H376.86V343.209ZM383.682 336.337H380.472V343.196H383.682V336.337ZM390.504 336.337H387.294V343.196H390.504V336.337ZM397.326 336.337H394.116V343.196H397.326V336.337ZM404.148 336.337H400.938V343.196H404.148V336.337Z",
    fill: "#EBF5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M376.86 356.853H373.65V349.993H376.86V356.853ZM383.682 349.98H380.472V356.84H383.682V349.98ZM390.504 349.98H387.294V356.84H390.504V349.98ZM397.326 349.98H394.116V356.84H397.326V349.98ZM404.148 349.98H400.938V356.84H404.148V349.98Z",
    fill: "#EBF5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M376.86 370.484H373.65V363.624H376.86V370.484ZM383.682 363.624H380.472V370.484H383.682V363.624ZM390.504 363.624H387.294V370.484H390.504V363.624ZM397.326 363.624H394.116V370.484H397.326V363.624ZM404.148 363.624H400.938V370.484H404.148V363.624ZM410.97 309.061H407.76V315.921H410.97V309.061ZM417.792 309.061H414.582V315.921H417.792V309.061ZM410.97 322.705H407.76V329.565H410.97V322.705ZM417.792 322.705H414.582V329.565H417.792V322.705ZM410.97 336.336H407.76V343.196H410.97V336.336ZM417.792 336.336H414.582V343.196H417.792V336.336ZM410.97 349.98H407.76V356.84H410.97V349.98ZM417.792 349.98H414.582V356.84H417.792V349.98ZM410.97 363.624H407.76V370.484H410.97V363.624ZM417.792 363.624H414.582V370.484H417.792V363.624Z",
    fill: "#EBF5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M408.114 404.557V383.247C408.114 381.863 406.981 380.73 405.597 380.73H301.517C300.133 380.73 299 381.863 299 383.247V454.274",
    stroke: "#C2D6D6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M307.508 395.784H304.299V388.924H307.508V395.784ZM314.33 388.911H311.121V395.771H314.33V388.911ZM321.152 388.911H317.943V395.771H321.152V388.911ZM327.974 388.911H324.765V395.771H327.974V388.911ZM334.796 388.911H331.587V395.771H334.796V388.911Z",
    fill: "#EBF5F5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M307.508 409.428H304.299V402.568H307.508V409.428ZM314.33 402.555H311.121V409.415H314.33V402.555ZM321.152 402.555H317.943V409.415H321.152V402.555ZM327.974 402.555H324.765V409.415H327.974V402.555ZM334.796 402.555H331.587V409.415H334.796V402.555Z",
    fill: "#EBF5F5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M307.508 423.059H304.299V416.199H307.508V423.059ZM314.33 416.199H311.121V423.059H314.33V416.199ZM321.152 416.199H317.943V423.059H321.152V416.199ZM327.974 416.199H324.765V423.059H327.974V416.199ZM334.796 416.199H331.587V423.059H334.796V416.199Z",
    fill: "#EBF5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M341.518 395.784H338.309V388.924H341.518V395.784ZM348.34 388.911H345.131V395.771H348.34V388.911ZM355.162 388.911H351.953V395.771H355.162V388.911ZM361.984 388.911H358.775V395.771H361.984V388.911ZM368.806 388.911H365.597V395.771H368.806V388.911Z",
    fill: "#EBF5F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M341.518 409.428H338.309V402.568H341.518V409.428ZM348.34 402.555H345.131V409.415H348.34V402.555ZM355.162 402.555H351.953V409.415H355.162V402.555ZM361.984 402.555H358.775V409.415H361.984V402.555ZM368.806 402.555H365.597V409.415H368.806V402.555Z",
    fill: "#EBF5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M341.518 423.059H338.309V416.199H341.518V423.059ZM348.34 416.199H345.131V423.059H348.34V416.199ZM355.162 416.199H351.953V423.059H355.162V416.199ZM361.984 416.199H358.775V423.059H361.984V416.199ZM368.806 416.199H365.597V423.059H368.806V416.199Z",
    fill: "#EBF5F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M375.251 395.784H372.041V388.924H375.251V395.784ZM382.073 388.911H378.863V395.771H382.073V388.911ZM388.895 388.911H385.685V395.771H388.895V388.911Z",
    fill: "#EBF5F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M375.251 409.428H372.041V402.568H375.251V409.428ZM382.073 402.555H378.863V409.415H382.073V402.555ZM388.895 402.555H385.685V409.415H388.895V402.555Z",
    fill: "#EBF5F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M375.251 423.059H372.041V416.199H375.251V423.059ZM382.073 416.199H378.863V423.059H382.073V416.199ZM388.895 416.199H385.685V423.059H388.895V416.199Z",
    fill: "#EBF5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M463.748 438.44V357.961C463.748 356.576 462.615 355.443 461.23 355.443H420.047C418.662 355.443 417.529 356.576 417.529 357.961V474.74",
    stroke: "#C2D6D6",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M426.038 370.484H422.828V363.625H426.038V370.484ZM432.847 363.625H429.638V370.484H432.847V363.625ZM439.669 363.625H436.46V370.484H439.669V363.625ZM446.491 363.625H443.282V370.484H446.491V363.625ZM453.313 363.625H450.104V370.484H453.313V363.625Z",
    fill: "#EBF5F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M426.038 384.128H422.828V377.269H426.038V384.128ZM432.847 377.269H429.638V384.128H432.847V377.269ZM439.669 377.269H436.46V384.128H439.669V377.269ZM446.491 377.269H443.282V384.128H446.491V377.269ZM453.313 377.269H450.104V384.128H453.313V377.269Z",
    fill: "#EBF5F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M426.038 397.772H422.828V390.913H426.038V397.772ZM432.847 390.913H429.638V397.772H432.847V390.913ZM439.669 390.913H436.46V397.772H439.669V390.913ZM446.491 390.913H443.282V397.772H446.491V390.913ZM453.313 390.913H450.104V397.772H453.313V390.913Z",
    fill: "#EBF5F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M426.038 411.416H422.828V404.557H426.038V411.416ZM432.847 404.557H429.638V411.416H432.847V404.557ZM439.669 404.557H436.46V411.416H439.669V404.557ZM446.491 404.557H443.282V411.416H446.491V404.557ZM453.313 404.557H450.104V411.416H453.313V404.557Z",
    fill: "#EBF5F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M426.038 425.06H422.828V418.201H426.038V425.06ZM432.847 418.201H429.638V425.06H432.847V418.201ZM439.669 418.201H436.46V425.06H439.669V418.201ZM446.491 418.201H443.282V425.06H446.491V418.201ZM453.313 418.201H450.104V425.06H453.313V418.201Z",
    fill: "#EBF5F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M426.038 438.704H422.828V431.844H426.038V438.704ZM432.847 431.832H429.638V438.692H432.847V431.832ZM439.669 431.832H436.46V438.692H439.669V431.832ZM446.491 431.832H443.282V438.692H446.491V431.832ZM453.313 431.832H450.104V438.692H453.313V431.832Z",
    fill: "#EBF5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166 395H162C159.79 395 158 393.21 158 391V114C158 111.79 159.79 110 162 110H166V395Z",
    fill: "#C2D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327 395H165C162.79 395 161 393.21 161 391V114C161 111.79 162.79 110 165 110H327C329.21 110 331 111.79 331 114V391C331 393.21 329.21 395 327 395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 127H161V142H331V127Z",
    fill: "#DBE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.5 249.32H170.26V292.35H322.5V249.32Z",
    stroke: "#DBE5E5",
    strokeWidth: 1.0831,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.5 121C321.12 121 320 119.88 320 118.5C320 117.12 321.12 116 322.5 116C323.88 116 325 117.12 325 118.5C325 119.88 323.88 121 322.5 121Z",
    fill: "#C1D6D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55 275C188.99 275 192.59 271.4 192.59 266.96C192.59 262.52 188.99 258.92 184.55 258.92C180.109 258.92 176.51 262.52 176.51 266.96C176.51 271.4 180.109 275 184.55 275Z",
    fill: "#DBE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.33 199.35C218.137 199.35 229.33 188.157 229.33 174.35C229.33 160.543 218.137 149.35 204.33 149.35C190.523 149.35 179.33 160.543 179.33 174.35C179.33 188.157 190.523 199.35 204.33 199.35Z",
    fill: "#DBE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.51 174.87L196.88 171.5L202.64 177.26L213.21 166.69L216.67 169.99L202.64 184.01L193.51 174.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.189 210.11H231.909",
    stroke: "#C2D6D6",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.061 309.68H250.341",
    stroke: "#C2D6D6",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.83 173.28H295.25",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.83 182.98H311.15",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.029 192.22H302.469",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.029 202.05H293.269",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.26 323.96H209.68",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.26 333.66H225.58",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.461 342.9H216.901",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.461 379.81H216.901",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42 261.33H260.59",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42 270.67H260.59",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42 280.67H249.68",
    stroke: "#DBE5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.84 221.32H224.25",
    stroke: "#C2D6D6",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.029 160.31H298.429",
    stroke: "#C2D6D6",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.801 118.5H208.201",
    stroke: "#C2D6D6",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.801 118.5H280.251",
    stroke: "#C2D6D6",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.92 134.5H188",
    stroke: "#A5BEBE",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.92 134.5H214",
    stroke: "#A5BEBE",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.92 134.5H240",
    stroke: "#A5BEBE",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.92 134.5H266",
    stroke: "#A5BEBE",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.92 134.5H291",
    stroke: "#A5BEBE",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.75 271.96H277.73C276.35 271.96 275.23 270.84 275.23 269.46V261.22C275.23 259.84 276.35 258.72 277.73 258.72H310.75C312.13 258.72 313.25 259.84 313.25 261.22V269.46C313.25 270.84 312.13 271.96 310.75 271.96Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.841 370.57H174.461C173.081 370.57 171.961 369.45 171.961 368.07V359.83C171.961 358.45 173.081 357.33 174.461 357.33H247.841C249.221 357.33 250.341 358.45 250.341 359.83V368.07C250.341 369.45 249.221 370.57 247.841 370.57Z",
    fill: "url(#paint1_linear)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M477.997 557C477.997 557 478.977 512.949 445.322 493.661C411.666 474.373 405.457 494.642 389.447 493.661C373.436 492.68 356.771 427.951 300.569 432.2C244.367 436.45 258.091 496.604 244.694 503.141C231.298 509.679 221.821 499.218 212.019 517.852C202.216 536.486 231.297 556.999 231.297 556.999L477.997 557Z",
    fill: "#21D0AC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M331.972 545.001C331.972 545.001 328.606 533.85 323.948 521.59C319.29 509.331 313.365 497.156 313.365 497.156C313.365 497.156 315.991 489.418 316.94 482.918C317.888 476.417 318.158 471.706 317.194 471.55C316.229 471.394 316.5 478.366 315.264 484.112C314.494 487.652 313.487 491.134 312.249 494.533C312.249 494.533 304.517 481.076 299.775 473.834C295.033 466.592 293.529 465.528 293.021 466.151C292.513 466.774 301.43 478.71 307.799 490.653C314.168 502.595 319.377 513.233 318.667 514.012C318.29 514.425 312.698 512.642 308.155 510.274C304.22 508.224 301.291 505.529 300.758 506.166C300.222 506.808 303.894 509.632 308.562 511.935C313.657 514.45 319.838 516.43 319.838 516.43C321.2 519.112 322.403 521.875 323.441 524.705C326.616 533.279 330.736 545.702 331.313 545.936C332.209 546.299 331.972 545.001 331.972 545.001Z",
    fill: "#08B195"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M400.022 539.922C399.349 538.882 414.097 526.33 414.097 526.33C413.76 523.732 413.602 521.114 413.626 518.493C413.688 514.813 414.232 510.866 415.04 511.004C415.848 511.141 414.922 514.471 415.04 517.869C415.166 521.521 415.646 525.081 415.646 525.081L430.192 515.72L431 517.107C431 517.107 425.175 520.193 417.262 525.775C409.349 531.356 400.696 540.962 400.022 539.922Z",
    fill: "#08B195"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M450.055 273.084H362.156V284.716H450.055V273.084Z",
    fill: "#1D1D1B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M487.901 554.838L485.099 538.42H467.734C467.734 538.42 471.333 547.659 472.594 554.838C476.093 554.838 487.901 554.838 487.901 554.838Z",
    fill: "#EFA592"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M472.594 554.838C471.002 559.241 463.671 567.051 459.442 570.142C455.528 573 448.314 578.65 446.274 581.873C444.217 585.097 447.153 587.207 456.523 587.174C465.893 587.141 473.572 585.629 479.46 579.763C485.347 573.897 488.83 570.873 492.346 570.291C492.645 562.664 487.918 554.838 487.918 554.838H472.594Z",
    fill: "#1D1D1B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M471.002 548.191H486.774L487.902 554.838C487.902 554.838 477.818 557.779 472.578 554.838C471.98 551.93 471.002 548.191 471.002 548.191Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M426.538 549.853L422.127 533.435H404.713C404.713 533.435 408.577 542.525 409.572 549.853C413.072 549.853 426.538 549.853 426.538 549.853Z",
    fill: "#EFA592"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M424.748 543.206L426.539 549.853C426.539 549.853 413.072 549.853 409.556 549.853C409.274 547.742 408.744 545.499 408.146 543.356L424.748 543.206Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M432.806 567.633H369.121C372.305 562.947 376.153 559.59 383.168 557.762C392.29 555.386 403.8 551.016 409.488 549.554C415.343 549.554 422.955 549.554 426.471 549.554C430.767 557.762 432.806 567.633 432.806 567.633Z",
    fill: "#1D1D1B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M362.156 284.716C362.156 284.716 362.09 288.471 362.09 300.202C362.09 311.934 363.433 369.079 364.461 383.685C367.646 428.816 399.87 533.435 399.87 533.435H422.127C422.127 533.435 405.509 431.392 404.713 420.043C404.132 411.751 401.943 354.656 401.346 327.537C404.58 336.527 424.465 424.446 427.981 437.241C432.276 452.877 462.809 538.404 462.809 538.404H485.115C485.115 538.404 475.43 489.185 464.285 434.798C455.213 390.515 454.55 338.222 453.588 331.292C451.465 316.038 450.055 284.716 450.055 284.716H362.156Z",
    fill: "#1D1D1B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M442.248 189.969C426.078 206.089 388.295 213.204 366.47 199.386C372.932 193.445 378.891 188.274 383.153 181.966C386.508 177.044 388.82 171.424 389.526 164.222C390.544 153.914 390.434 150.332 390.172 141.095C389.872 130.731 404.572 128.09 412.728 131.725C415.925 133.141 418.126 135.531 418.027 138.783C417.746 147.846 417.613 154.692 418.127 160.099C419.814 177.403 424.512 186.916 442.248 189.969Z",
    fill: "#EFA592"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M412.726 131.725C405.638 161.484 394.843 174.868 383.151 181.966C386.505 177.044 388.818 171.424 389.524 164.222C390.542 153.914 390.432 150.332 390.169 141.095C389.87 130.731 404.57 128.09 412.726 131.725Z",
    fill: "url(#paint2_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M421.486 132.923C426.081 128.228 429.107 124.645 429.578 118.811C430.05 112.977 428.265 108.311 420.154 104.563C412.044 100.815 407.036 99.1099 401.708 91.9267C397.221 85.8778 390.484 86.6652 384.9 91.7507C379.96 96.2368 376.886 102.357 377.206 109.165C377.525 115.974 378.348 119.133 388.938 120.199C399.528 121.266 396.303 139.373 404.379 141.137C412.455 142.901 416.925 137.579 421.486 132.923Z",
    fill: "#1D1D1B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M407.313 112.101C404.961 109.431 401.308 108.017 397.92 107.838C390.304 107.457 384.317 108.056 378.56 121.503C372.967 134.517 378.045 148.683 380.891 152.716C384.17 157.369 390.03 158.785 394.584 157.393C401.788 155.182 409.677 147.284 413.431 141.455C420.073 139.509 424.425 134.305 423.87 129.958C423.254 125.106 418.291 120.371 412.043 127.151C409.414 130.009 406.77 135.146 406.77 135.146C403.647 133.743 402.807 127.924 404.519 125.215C406.23 122.505 406.846 120.45 407.977 118.444C409.105 116.401 408.681 113.666 407.313 112.101Z",
    fill: "#EFA592"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M451.073 239.026V249.582V286.334H362.396C360.637 286.334 359.213 284.921 359.213 283.174V280.761C361.749 267.698 363.896 249.553 358.283 252.877C345.42 260.495 322.624 261.477 312.362 255.705C299.928 248.712 299.651 230.613 312.603 220.565C326.772 209.571 343.701 210.797 350.58 202.548C358.965 192.494 364.097 184.129 374.482 184.129C374.482 184.129 387.446 184.485 395.095 177.422L396.825 192.839L402.998 176.861C412.454 179.18 423.399 178.152 432.702 175.465C443.417 172.369 452.361 179.765 463.235 188.119C471.962 194.819 497.8 235.661 487.049 260.974C477.358 283.793 459.911 284.342 451.108 281.766C450.855 272.208 451.073 246.638 451.073 239.026Z",
    fill: "#A5BEBE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M389.035 233.336V234.913",
    stroke: "#7D9696",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M389.035 249.121V250.704",
    stroke: "#7D9696",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M389.035 217.545V219.122",
    stroke: "#7D9696",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M389.035 201.754V203.331",
    stroke: "#7D9696",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M381.903 168.869C381.903 168.869 389.635 174.816 395.107 177.416C391.971 181.874 388.411 185.396 384.58 192.553C379.437 190.099 373.306 184.164 371.693 180.711C375.318 175.465 381.903 168.869 381.903 168.869Z",
    fill: "#A5BEBE"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M371.688 180.711C373.3 184.164 379.431 190.099 384.574 192.553C388.405 185.396 391.965 181.874 395.101 177.416L396.831 192.833V286.328",
    stroke: "#7D9696",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M415.309 226.874V214.525H439.246V219.122H415.309",
    stroke: "#7D9696",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M403.01 176.861C403.01 176.861 407.311 185.408 407.688 193.394C415.549 192.652 434.008 181.973 434.879 174.863C430.513 168.869 425.329 164.973 425.329 164.973C419.062 172.567 406.94 175.652 403.01 176.861Z",
    fill: "#A5BEBE"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M403.01 176.861C403.01 176.861 407.311 185.408 407.688 193.394C415.549 192.652 434.008 181.973 434.879 174.863",
    stroke: "#7D9696",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M334.27 197.84C338.695 194.983 340.324 190.21 342.419 190.21C344.514 190.21 345.667 187.09 347.244 187.09C348.821 187.09 352.429 185.355 354.176 186.395C355.924 187.435 359.902 189.865 361.173 191.022C362.444 192.179 364.397 198.144 365.356 199.879C366.316 201.614 362.72 202.151 361.22 200.177C358.878 197.092 341.554 200.328 339.454 199.914L334.27 197.84Z",
    fill: "#FFC9B4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M387.205 243.203H316.993C315.581 243.203 314.369 242.192 314.121 240.814L306.56 198.243C306.248 196.473 307.619 194.849 309.432 194.849H379.643C381.055 194.849 382.268 195.859 382.515 197.238L390.076 239.815C390.388 241.579 389.017 243.203 387.205 243.203Z",
    fill: "#1D1D1B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M385.234 243.203H315.022C313.61 243.203 312.398 242.192 312.151 240.814L304.589 198.243C304.277 196.473 305.648 194.849 307.461 194.849H377.678C379.091 194.849 380.303 195.859 380.55 197.238L388.111 239.815C388.417 241.579 387.046 243.203 385.234 243.203Z",
    fill: "#1D1D1B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M334.953 216.879L336.377 224.894C336.489 225.507 336.919 226.074 337.507 226.378L345.31 230.403C345.892 230.701 346.545 230.701 347.022 230.403L353.395 226.378C353.877 226.074 354.107 225.507 354.001 224.894L352.577 216.879C352.465 216.265 352.035 215.699 351.447 215.395L343.644 211.37C343.062 211.072 342.409 211.072 341.932 211.37L335.559 215.395C335.077 215.699 334.847 216.265 334.953 216.879Z",
    fill: "#23D1AE"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M383.703 224.876C383.191 223.685 380.208 223.112 377.613 221.623C373.776 219.42 362.19 214.495 362.19 214.495C362.19 214.495 361.772 210.68 366.88 211.212C369.322 211.469 374.553 214.308 377.701 215.389C380.384 216.312 386.363 218.935 386.145 217.72C386.145 217.72 385.268 213.531 385.262 212.749C388.428 212.731 396.578 216.768 397.054 219.648C397.549 222.651 397.549 225.233 400.279 227.33C407.617 232.979 429.359 243.612 438.88 240.627C440.916 246.013 440.763 264.012 437.745 271.753C412.854 268.055 396.872 246.509 394.53 245.031C391.923 243.384 386.163 239.645 382.167 238.693",
    fill: "#FFC9B4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M373.558 219.484C371.599 219.04 365.75 216.85 363.349 216.645C359.618 216.324 359.342 219.864 359.342 219.864C359.342 219.864 363.484 221.12 363.973 221.593C361.066 221.938 361.101 224.777 361.101 224.777C361.101 224.777 374.67 230.935 377.077 232.833C379.484 234.732 386.115 235.883 387.81 236.724C388.71 232.296 385.768 224.024 383.838 222.99C381.914 221.956 376.436 220.133 373.558 219.484Z",
    fill: "#FFC9B4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M368.015 228.008C365.002 227.494 364.02 230.467 364.02 230.467C364.02 230.467 376.088 236.888 377.548 237.484C379.007 238.079 387.233 239.744 389.557 240.597C390.422 238.044 387.204 233.786 385.056 233.867C382.908 233.949 371.487 228.604 368.015 228.008Z",
    fill: "#FFC9B4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M417.69 236.514C417.69 236.514 414.424 240.574 414.312 244.582",
    stroke: "#FFA599",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M426.917 240.031C426.917 240.031 423.91 245.131 423.934 248.852",
    stroke: "#FFA599",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M445.441 286.334C435.008 286.334 425.281 281.684 425.281 281.684L431.224 239.061L445.588 240.802L445.441 286.334Z",
    fill: "#A5BEBE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M445.429 253.274L445.588 240.802L431.224 239.061L425.281 281.684",
    stroke: "#7D9696",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 135,
    y: 97,
    width: 209,
    height: 321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.819608 0 0 0 0 0.682353 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 277.909,
    y1: 274.764,
    x2: 310.575,
    y2: 255.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23D1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EFF33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 179.685,
    y1: 382.118,
    x2: 242.617,
    y2: 345.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23D1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EFF33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 399.878,
    y1: 180.592,
    x2: 395.813,
    y2: 130.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00741235,
    stopColor: "#DD8B7A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD8B7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeyChat);
export default __webpack_public_path__ + "static/media/hey-chat.09da27d9136b607eae173983134f165a.svg";
export { ForwardRef as ReactComponent };